import ComparisonWrapper from './ComparisonWrapper'
import comparisonWrapperContainer from './comparisonWrapperContainer'

export default comparisonWrapperContainer(ComparisonWrapper)
